import React from 'react';
import Icon from '../Icon';
import CustomTooltip from '../../components/Tooltip';
import UserStore from '../../stores/UserStore';
import { I18nFormatter } from '../../utils/I18n/I18n';

export const renderCplAmount = (commissionContract, key) => {
    if (!commissionContract) return null;

    const staticNames = UserStore.getTranslation().offersPage.offer;

    return (
        +commissionContract.promotion_cpl.amount
            ? (
                <React.Fragment>
                    {I18nFormatter.currency(
                        +commissionContract.cpl.amount + +commissionContract.promotion_cpl.amount,
                        commissionContract.cpl.currency)
                    }&nbsp;
                    <CustomTooltip id={key} theme={'white'} tooltip={(
                        <React.Fragment>
                            <p>{staticNames.commissionContract}: {I18nFormatter.currency(commissionContract.cpl.amount, commissionContract.cpl.currency)}</p>
                            <p>{staticNames.promotionCommission}: {I18nFormatter.currency(+commissionContract.promotion_cpl.amount, commissionContract.promotion_cpl.currency)}</p>
                        </React.Fragment>
                    )}>
                        <Icon name={'fa-arrow-up text-navy'} />
                    </CustomTooltip>
                </React.Fragment>
            )
            : I18nFormatter.currency(commissionContract.cpl.amount, commissionContract.cpl.currency)
    );
};

export const renderCps = (commissionContract, key) => {
    if (!commissionContract) return null;

    const staticNames = UserStore.getTranslation().offersPage.offer;
    let dynamicCps = commissionContract.dynamic_cps;

    return (
        commissionContract.promotion_cps
            ? (
                <React.Fragment>
                    {I18nFormatter.percentage(commissionContract.cps + commissionContract.promotion_cps)}&nbsp;
                    <CustomTooltip id={key} theme={'white'} tooltip={(
                        <React.Fragment>
                            <p>{staticNames.commissionContract}: {I18nFormatter.percentage(commissionContract.cps)}</p>
                            <p>{staticNames.promotionCommission}: {I18nFormatter.percentage(commissionContract.promotion_cps)}</p>
                        </React.Fragment>
                    )}>
                        <Icon name={'fa-arrow-up text-navy'} />
                    </CustomTooltip>
                </React.Fragment>
            )
            : dynamicCps.length <= 0
                ? I18nFormatter.percentage(commissionContract.cps)
                : Object.keys(dynamicCps).map((option, i) => (
                        <p key={i}>{option} -> {I18nFormatter.percentage(dynamicCps[option])}</p>
                ))

    );
};

export const renderCplAmountMin = (commissionContract, key) => {
    if (!commissionContract) return null;

    const staticNames = UserStore.getTranslation().offersPage.offer;

    return (
        +commissionContract.cpl_amount_min.amount
            ? (
                <React.Fragment>
                    {I18nFormatter.currency(
                        +commissionContract.cpl_amount_min.amount,
                        commissionContract.cpl_amount_min.currency)
                    }&nbsp;
                    <CustomTooltip id={key} theme={'white'} tooltip={(
                        <React.Fragment>
                            <p>{staticNames.commissionContract}: {I18nFormatter.currency(commissionContract.cpl_amount_min.amount, commissionContract.cpl_amount_min.currency)}</p>
                        </React.Fragment>
                    )}>
                        <Icon name={'fa-arrow-to'} />
                    </CustomTooltip>
                </React.Fragment>
            )
            : I18nFormatter.currency(commissionContract.cpl_amount_min.amount, commissionContract.cpl_amount_min.currency)
    );
};